module.exports = __webpack_public_path__ + "media/images/soar/site/woman_03-d235bd0b3af68702e63474b9c00c7aed.svg";